import React from 'react'

import './index.scss'

export const UploadIcon: React.FC = () => (
  <svg className="icon icon--upload" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      d="M20.06,5.12h-15v15h15Zm-2,2v7L15.37,11l-3.27,4.1-2-1.58-3,3.74V7.12Z"
    />
    <circle className="fill" cx="9.69" cy="9.47" r="0.97" />
  </svg>
)
